export default class BaseService {
  static async parseResponse (response) {
    const { status, data } = response

    if (status < 200 || status >= 300) {
      if (status === 401) {
        window.location.reload()
      }
    }

    return data
  }
}
